// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uye4","largestCol":"styles_largestCol__3EEr9","smallestCol":"styles_smallestCol__38Gzk"};